import {ActionTypes} from '../actions';
import {addItem, removeItem} from '../../common/util/array';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'loadingReasons': false,
  'needConfirmation': false,
  'orderReasons': [],
  'list': [],
  'unconfirmedOrder': null,
  'errorCode': '',
  'errorMessage': '',
  'vehicleInf': '',
};

export const dealerSpecialOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_DEALER_SPECIAL_ORDER]: (state, action) => (INITIAL_STATE),
    [ActionTypes.REMOVE_ELEMENT_FROM_SPECIAL_ORDER]: (state, action) => ({
      ...state,
      'list': removeItem(state.list, action.payload),
    }),
    [ActionTypes.CLOSE_DEALER_SPECIAL_ORDER_CONFIRMATION]: (state, action) => ({
      ...state,
      'needConfirmation': false,
      'unconfirmedOrder': null,
      'errorMessage': '',
      'errorCode': '',
    }),
    [ActionTypes.GET_SPECIAL_ORDERS_REASONS_REQUEST]: (state, action) => ({
      ...state,
      'loadingReasons': true,
    }),
    [ActionTypes.GET_SPECIAL_ORDERS_REASONS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingReasons': false,
      'orderReasons': action.response.data,
    }),
    [ActionTypes.GET_SPECIAL_ORDERS_REASONS_FAILED]: (state, action) => ({
      ...state,
      'loadingReasons': false,
      'orderReasons': [],
    }),
    [ActionTypes.CHECK_DEALER_SPECIAL_ORDER_ELEMENT_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CHECK_DEALER_SPECIAL_ORDER_ELEMENT_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': addItem(state.list, {...action.payload, ...action.response.data}),
    }),
    [ActionTypes.CHECK_DEALER_SPECIAL_ORDER_ELEMENT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'needConfirmation': true,
      'unconfirmedOrder': action.payload,
      'errorCode': action.error.data.status,
      'errorMessage': action.error.data.error,
    }),
    [ActionTypes.CREATE_DEALER_SPECIAL_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATE_DEALER_SPECIAL_ORDER_SUCCESS]: (state, action) => ({
      ...INITIAL_STATE,
      'orderReasons': state.orderReasons,
    }),
    [ActionTypes.CREATE_DEALER_SPECIAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_VEHICLE_INF]: (state, action) => ({
      ...state,
      'loadingReasons': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_INF]: (state, action) => ({
      ...state,
      'loadingReasons': false,
      'vehicleInf': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_INF_FAILED]: (state, action) => ({
      ...state,
      'loadingReasons': false,
      'vehicleInf': '',
    }),
  })(state, action);
};
